import { stitch } from 'keo';
import PropTypes from 'prop-types';
import r from 'render-dom';

import './index.css';

const propTypes = {
    children: PropTypes.node.isRequired,
    sizes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

const style = {
    height: '100%',
    width: '100%',
};

const render = ({ props: { children, sizes = [] } }) => (
    r.span({
        className: sizes.map((size) => `${size}-hidden`).join(' '),
        style,
    }, [
        children,
    ])
);

export default stitch({ propTypes, render });



// WEBPACK FOOTER //
// ./src/components/shared/HiddenOnSize/index.js